import { useFormik } from "formik";
import { articleFormSchema } from "libs/validation/schemas";
import mediaUploader from "api/mediaUploader.api";
import useAuth from "hooks/useAuth";
import { CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { runFireworks } from "components/confetti";

const FIELDS = {
  TITLE: "title",
  DESCRIPTION: "description",
  CONTENT: "content",
  CACHE_SIZE_UNLIMITED,
  CATEGORIES: "categories",
  PUBLISHED: "published",
  PREDICTOR: "predictor",
  LEVEL: "level",
  DEADLINE: "deadline",
  END_OF_VOTING: "endOfVoting",
  IMAGE: "image",
};

const usePromiseForm = (props) => {
  const { promise, create, update, id } = props;
  const { currentUser } = useAuth();
  const promiseForm = useFormik({
    initialValues: {
      [FIELDS.TITLE]: promise.title || "",
      [FIELDS.DESCRIPTION]: promise.description || "",
      [FIELDS.CONTENT]: promise.content || "",
      [FIELDS.CATEGORIES]: promise.categories || [],
      [FIELDS.PUBLISHED]: promise.published || false,
      [FIELDS.PREDICTOR]: promise.predictor || "",
      [FIELDS.LEVEL]: promise.level || 1,
      [FIELDS.DEADLINE]: promise.deadline || "",
      [FIELDS.END_OF_VOTING]: promise.endOfVoting || "",
      [FIELDS.IMAGE]: promise.image || "",
    },
    enableReinitialize: true,
    validationSchema: articleFormSchema,
    onSubmit: async (values) => {
      let contentUrl = "";
      let imageUrl = "";

      if (typeof values[FIELDS.IMAGE] !== "string") {
        imageUrl = await mediaUploader(
          values[FIELDS.IMAGE],
          `promises/${id}/image`,
        );
      } else {
        imageUrl = values[FIELDS.IMAGE];
      }

      if (values[FIELDS.CONTENT]) {
        const blob = new Blob([values[FIELDS.CONTENT]], { type: "text/plain" });
        const file = new File([blob], "content.txt", { type: "text/plain" });
        contentUrl = await mediaUploader(file, `promises/${id}/content`);
      }

      create({
        ...values,
        image: imageUrl,
        createdAt: Date.now(),
        content: contentUrl,
        author: { id: currentUser?.id, displayName: currentUser.displayName },
        type: "pending",
      });
      update(id, {
        ...values,
        image: imageUrl,
        content: contentUrl,
        updatedAt: Date.now(),
      });
      runFireworks();
    },
  });

  const { values, setFieldValue, handleSubmit, resetForm } = promiseForm;

  return {
    promiseForm,
    FIELDS,
    values,
    setFieldValue,
    handleSubmit,
    resetForm,
    errors: promiseForm.errors,
  };
};

export default usePromiseForm;
